<template>
  <div class="combination-text" :class="{
    'combination-text--small': size === 'small'
  }">
    <div class="combination-text__input">
      <div
        v-if="isUseRichText"
        class="combination-text__richeditor"
        contenteditable
        @blur="onTextChange"
        v-html="richText"
      ></div>
      <yxt-input
        v-else
        ref="input"
        v-model="richText"
        type="textarea"
        :autosize="{ minRows: 1 }"
        @blur="trimInput"
        @focus="$event => $event.currentTarget.select()"
      ></yxt-input>
    </div>
  </div>
</template>

<script>
import { replaceHtmlTags } from '../../../utils';

export default {
  name: 'CommonAttachmentTextfield',
  components: {},
  props: {
    content: {
      // 输入文字
      type: String,
      default: ''
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      richText: this.content
    };
  },
  computed: {
    isUseRichText() {
      if (this.content) {
        const contentText = replaceHtmlTags(
          this.content
            .replace('<br>', '')
            .replace('<br/>', '')
            .replace('<br />', '')
        );

        return (
          this.content !== contentText ||
          this.content.indexOf('<') >= 0 ||
          this.content.indexOf('>') >= 0
        );
      }
      return false;
    }
  },
  watch: {
    content(val) {
      this.richText = val;
    },
    richText(val) {
      this.$emit('update:content', val);
    }
  },
  mounted() {
    if (this.autoFocus && this.$refs.input) {
      this.$refs.input.focus();
    }
  },
  methods: {
    onTextChange(val) {
      if (val) {
        this.richText = val.target.innerHTML;
      }
    },
    trimInput() {
      if (this.richText) {
        this.richText = this.richText.trim();
      }
    }
  }
};
</script>
